
const texts = {
    titulo: 'Personas firmantes a notificar',
    subtitulo: 'Estas personas recibirán una invitación para firmar el documento',
    noFirmantes: 'Todavía no agregaste personas para firmar',
    buttons: {
      delete: 'Eliminar',
    },
  };
  
  export default texts;
  